import { atom } from "recoil";

export const createDefaultWebhookPresetFormData = () => ({
	id: null,
	name: "",
	method: "POST",
	url: "",
	headersText: "{\n  \"Content-Type\": \"application/json\"\n}",
	bodyTemplate:
		"{\n  \"name\": \"{{name}}\",\n  \"tg\": \"{{tg}}\",\n  \"phone\": \"{{phone}}\",\n  \"email\": \"{{email}}\",\n  \"uid\": \"{{uid}}\",\n  \"magicLink\": \"{{magicLink}}\",\n  \"projectMirror\": \"{{projectMirror}}\"\n}",
	active: true,
});

export const webhookPresetModalStore = atom({
	key: "webhookPresetModalStore",
	default: {
		show: false,
		mode: "add",
		loaded: true,
		formData: createDefaultWebhookPresetFormData(),
	},
});
